/**
 * Topbar.jsx
 * Theme toggle and the signed-in account, above every page.
 *
 * On a phone it is also the app bar: a menu button that opens the sidebar
 * drawer, and the wordmark. Both are hidden on a desktop by mobile.css.
 */

import { NavLink } from 'react-router-dom';
import { Sun, Moon, Chevron, Menu } from './Icons.jsx';
import { useTheme } from '../hooks/useTheme.jsx';
import { useSession } from '../hooks/useSession.jsx';
import NotificationBell from './NotificationBell.jsx';

export default function Topbar({ menuOpen, onMenu }) {
  const { theme, toggle } = useTheme();
  const { user } = useSession();

  return (
    <div className="topbar">
      <button
        className="icon-btn topbar__menu"
        onClick={onMenu}
        aria-label="Open menu"
        aria-expanded={menuOpen}
        aria-controls="sidebar"
      >
        <Menu size={22} />
      </button>

      <NavLink to="/" className="topbar__brand" aria-label="Kreeboom home">
        Kree<span>boom</span>
      </NavLink>

      <NotificationBell />

      <button
        className="icon-btn"
        onClick={toggle}
        aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
        title={theme === 'dark' ? 'Light theme' : 'Dark theme'}
      >
        {theme === 'dark' ? <Sun /> : <Moon />}
      </button>

      <div className="topbar__account" title={user || 'Not signed in'}>
        <span className="avatar">K</span>
        KreeBoom
        <Chevron size={16} />
      </div>
    </div>
  );
}
